<template>
  <Modal :modalVisible="modal" @close="toggle" width="500px" id="confirm-cancel-order-modal">
    <div slot="modal-content" class="text-left text-black">
      <p class="text-3xl font-extrabold mb-4">Pesanan ini sedang dalam pengajuan pembatalan</p>
      <p class="text-justify">Mohon tunggu hinga proses verifikasi selesai. Anda akan menerima notifikasi setelah
        pembatalan dikonfirmasi
      </p>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
  components: {
    Modal: () => import(/* webpackChunkName: "Modal" */ '@/components/Modal/Modal'),
  }
}
</script>

<style scoped>
/* opsional styling */
</style>
